var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.resimlerList),function(item,index){return _c('b-badge',{key:index,staticStyle:{"float":"left","width":"20%"}},[_c('vs-card',[_c('img',{staticClass:"grid-view-img px-4",staticStyle:{"width":"100%"},attrs:{"src":_vm.cevir(item.STOCKPICTURE)}})])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }